import {
	Component,
	OnInit,
	Input,
	forwardRef,
	ViewEncapsulation,
} from '@angular/core';
import { FnUiFieldMetaDataService } from './service/fn-ui-field-metadata.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FnInputValueAccessor } from '../../core/model/fn-input.value.accessor';
import { FnInputModel } from '../../core/model/fn-input.model';
import { FN_INPUT_TYPES } from '../../core/model/fn-form.constant';

/**
 * This component set the Properties of FNBaseComponent to create input box of different types.
 * To use this component import FnInputModule in Module.
 */
@Component({
	selector: 'fn-input',
	templateUrl: 'fn-input.component.html',
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FnInputComponent),
			multi: true,
		},
	],
})
export class FnInputComponent extends FnInputValueAccessor<any>
	implements OnInit {
	/**
	 * member with different Types of values input can be created.
	 */
	inputTypeMap = FN_INPUT_TYPES;

	/**
	 * member of string type
	 * Defines the type of input box to create
	 */
	type = '';
	/**
	 * member of FnIputModel type
	 * use to set the configuration of input box
	 */
	config: FnInputModel;

	/**
	 * optional member of any type
	 * used to put data in input box which matches the given pattern
	 *
	 */
	pattern?: any;

	/**
	 * Creates an instance of fn input component.
	 * @param fieldMetaDataSvcs FnUiFieldMetaDataService refernce
	 */
	constructor(private fieldMetaDataSvcs: FnUiFieldMetaDataService) {
		super();
	}

	/**
	 * Input member of string type
	 * used to set the name of input box
	 */
	@Input() name = '';

	/**
	 *  Input member
	 *  default value ='off'
	 *  allow the browser to predict the value if autocomplete is on
	 */
	@Input() autocomplete = 'off';
	/**
	 * Input member
	 * default value = 0
	 * used to set the tabindex of input tag
	 */
	@Input() tabindex = 0;
	/**
	 * Input member
	 * used to align the text in input box or text area
	 * default value is left
	 * type ('left' | 'right' | 'center' | 'justify')
	 */
	@Input() textAlign: 'left' | 'right' | 'center' | 'justify' = 'left';
	/**
	 * Input  member
	 * used to show the placeholder in input box
	 * default value is ''
	 */
	@Input() placeholder = '';
	/**
	 * Input  member
	 * used to pass the form object to show error message
	 * if validation is used in FormControl
	 */
	@Input() parentForm: any;
	/**
	 * Input member variable
	 * value used to get the config object from FieldMetaDataSvcs by id
	 */
	@Input() dataKey = '';

	/**
	 * Implements onInit event handler.
	 * set the config and type member variable.
	 */
	ngOnInit() {
		this.config = this.fieldMetaDataSvcs.getFieldForId(this.dataKey);
		this.type = this.config.typeID.iid;
	}
}
